<section id="encrypted-login">
  <div class="encrypted">
    <div class="encrypted-message">
      <i class="ti-warning-circle ti-lg encrypted-message-icon"></i>
      <p class="encrypted-message-text" *ngIf="fromWhere === 'trash'">
        {{ 'ECRYPTED_FILE_IN_TRASH' | translate }}
        <span class="encrypted-message-login" (click)="routeToLogin()">{{ 'HERE' | translate }}</span>
        {{ 'LOGIN_ECRYPTED_STORAGE' | translate }}
      </p>
      <p class="encrypted-message-text" *ngIf="fromWhere === 'favorite'">
        {{ 'ECRYPTED_FILE_IN_FAVORITES' | translate }}
        <span class="encrypted-message-login" (click)="routeToLogin()">{{ 'HERE' | translate }}</span>
        {{ 'LOGIN_ECRYPTED_STORAGE' | translate }}
      </p>
      <p class="encrypted-message-text" *ngIf="fromWhere === 'sharedToMeHistory' || fromWhere === 'sharedToMe'">
        {{ 'ECRYPTED_FILE_IN_SHARED_WITH_ME' | translate }}
        <span class="encrypted-message-login" (click)="routeToLogin()">{{ 'HERE' | translate }}</span>
        {{ 'LOGIN_ECRYPTED_STORAGE' | translate }}
      </p>
      <p class="encrypted-message-text" *ngIf="fromWhere === 'mySharesHistory' || fromWhere === 'myShares'">
        {{ 'ECRYPTED_FILE_IN_MY_SHARED' | translate }}
        <span class="encrypted-message-login" (click)="routeToLogin()">{{ 'HERE' | translate }}</span>
        {{ 'LOGIN_ECRYPTED_STORAGE' | translate }}
      </p>
      <p class="encrypted-message-text" *ngIf="fromWhere === 'recents'">
        {{ 'ECRYPTED_FILE_IN_RECENT_DATES' | translate }}
        <span class="encrypted-message-login" (click)="routeToLogin()">{{ 'HERE' | translate }}</span>
        {{ 'LOGIN_ECRYPTED_STORAGE' | translate }}
      </p>
    </div>
    <i class="ti-close ti-lg encrypted-close" (click)="close()"></i>
  </div>
</section>
